import { Controller } from 'stimulus';
import dataLayer from '../tracking/dataLayer';
import controllerForElement from '../helpers/controllerForElement';

class CardQuiz extends Controller {
  connect() {
    this.answered = {};

    const identifier = this.data.get('identifier');

    if (identifier && window.location.href.indexOf(`#${identifier}`) >= 0) {
      this.onOpen();
    }

    if (identifier) {
      const links = Array.prototype.slice.call(document.querySelectorAll(`[href="#${identifier}"]`));

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.onOpen();
        });
      });
    }
  }

  onOpen() {
    this.element.removeAttribute('hidden');

    dataLayer.event('Quiz', 'open');
  }

  onClose() {
    this.element.setAttribute('hidden', 'hidden');

    dataLayer.event('Quiz', 'close');
  }

  onLove() {
    const { question } = this.activeCard().dataset;

    this.answered[question] = 1;

    dataLayer.event('Quiz', 'love_answer', question);

    this.moveToCard(this.nextCard());
  }

  onNope() {
    const { question } = this.activeCard().dataset;

    this.answered[question] = 0;

    dataLayer.event('Quiz', 'failure_answer', question);

    this.moveToCard(this.nextCard());
  }

  onEndReached() {
    let { successThreshold } = this.confirmationTarget.dataset;

    if (!successThreshold || Number.isNaN(parseInt(successThreshold, 10))) {
      successThreshold = 1;
    }

    const lovedAnswers = Object.values(this.answered).filter((answer) => answer === 1).length;

    this.confirmationTarget.removeAttribute('hidden');

    if (lovedAnswers >= successThreshold) {
      this.confirmationSuccessTarget.removeAttribute('hidden');
    } else {
      this.confirmationFailureTarget.removeAttribute('hidden');
    }

    dataLayer.event('Quiz', 'end');
  }

  onApply() {
    this.element.setAttribute('hidden', 'hidden');

    dataLayer.event('Quiz', 'apply');

    const applyModal = document.getElementById('vacancy-submit-modal');

    if (applyModal) {
      controllerForElement(applyModal, 'modal').then((controller) => {
        controller.dialog.show();
      });
    }
  }

  moveToCard(card) {
    // Remove the current active card from the stack
    this.activeCard().classList.add('is-past');
    this.activeCard().classList.remove('is-active');

    if (!card) {
      this.onEndReached();
      return;
    }

    // Change the new card to being active
    card.classList.add('is-active');

    this.renumberDeltas(card);
  }

  renumberDeltas(activeCard) {
    const activeIndex = this.cardTargets.indexOf(activeCard);

    this.cardTargets.forEach((card, index) => {
      const delta = index - activeIndex;
      card.dataset.delta = delta;
    });
  }

  activeCard() {
    return this.cardTargets.find((card) => card.classList.contains('is-active'));
  }

  nextCard() {
    const activeCard = this.activeCard();
    return activeCard.nextElementSibling;
  }
}

CardQuiz.targets = [
  'card',
  'confirmation',
  'confirmationSuccess',
  'confirmationFailure',
];

export default CardQuiz;
